import { Reveal, SectionLabel } from "./Reveal";

const steps = [
  {
    n: "01",
    title: "साइट निरीक्षण",
    en: "Site Inspection & Scope",
    desc: "हम आपकी साइट का मुफ्त निरीक्षण कर काम का दायरा तय करते हैं।",
  },
  {
    n: "02",
    title: "कोटेशन व SLA समझौता",
    en: "Quotation & SLA",
    desc: "आपकी ज़रूरत के हिसाब से अनुकूलित कोटेशन और लिखित SLA समझौता।",
  },
  {
    n: "03",
    title: "स्टाफ की तैनाती",
    en: "Staff Deployment",
    desc: "सुपरवाइजर की निगरानी में प्रशिक्षित, वेरिफाइड स्टाफ की तैनाती।",
  },
  {
    n: "04",
    title: "दैनिक चेकलिस्ट व फीडबैक",
    en: "Daily Checklist & Feedback",
    desc: "रोज़ की चेकलिस्ट और फीडबैक ट्रैकिंग से गुणवत्ता हमेशा बनी रहती है।",
  },
];

export const Process = () => (
  <section id="process" data-testid="process-section" className="py-24 md:py-32 border-t border-white/10">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12">
      <Reveal>
        <SectionLabel>[ 05 — कार्य प्रणाली / PROCESS ]</SectionLabel>
        <h2 className="mt-4 font-khand font-bold text-4xl sm:text-5xl lg:text-6xl leading-tight">
          चार कदम, <span className="text-[#00F0FF]">पूरा भरोसा</span>
        </h2>
      </Reveal>
      <div className="mt-16">
        {steps.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.05}>
            <div
              data-testid={`process-step-${i}`}
              className="group relative border-t border-white/10 last:border-b py-10 md:py-14 grid grid-cols-12 gap-4 items-center overflow-hidden"
            >
              <span className="absolute -left-2 top-1/2 -translate-y-1/2 font-spacemono font-bold text-[22vw] md:text-[13vw] leading-none text-white/5 select-none pointer-events-none transition-colors duration-700 group-hover:text-[#00F0FF]/10">
                {s.n}
              </span>
              <div className="relative col-span-12 md:col-span-5 md:pl-24">
                <p className="font-spacemono text-[10px] tracking-[0.3em] text-[#00F0FF] uppercase">
                  STEP {s.n} — {s.en}
                </p>
                <h3 className="mt-3 font-khand font-semibold text-3xl md:text-5xl leading-tight">
                  {s.title}
                </h3>
              </div>
              <p className="relative col-span-12 md:col-span-6 md:col-start-7 text-sm md:text-lg text-slate-400 font-mukta leading-relaxed">
                {s.desc}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
